import React from 'react';

interface ITimelineProps {
  currentIndex: number;
}

const Timeline = ({ currentIndex }: ITimelineProps) => {
  const timelineWidth = currentIndex * (100 * 0.5);

  return (
    <div className='guide-list-timeline-wrapper'>
      <div className='timeline-back' />
      <div
        className='timeline-front'
        style={{ height: `calc(${timelineWidth}% - 20px)` }}
      />
    </div>
  );
};

export default Timeline;
